import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_azjmuj2qt2: FaireBrandEntity = {
  token: "b_azjmuj2qt2",
  type: "brand",
  name: "Folie à Trois",
  avatarUrl:
    "https://cdn.faire.com/fastly/a2f6885c4fd39702b352c4e040b7a45218bb86038e667b8516a1a7ffd74f8b45.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/48d3745bd3ecfe51b2440ed8e277a26cbf0e82760d66b2f5ad588a08f22bac6a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a2f6885c4fd39702b352c4e040b7a45218bb86038e667b8516a1a7ffd74f8b45.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/48d3745bd3ecfe51b2440ed8e277a26cbf0e82760d66b2f5ad588a08f22bac6a.jpeg",
  location: "BEL",
  minimumOrderDollars: 151,
  rating: 4.6,
  reviewCount: 13,
  isInsider: false,
  description:
    "Folie à Trois – Made for women by women. We craft fine jewellery using sustainable sterling silver and stainless steel, plated with 3 micron 18k gold. Which makes our jewellery long-lasting, waterproof and hypoallergenic.\n\nIt doesn't have to stop at jewelry! You can never have enough accessories therefore we have a wide range of cell phone cords, jewelry boxes and all kinds of hair accessories.\n\nNot only are our pieces designed to be affordable, we also aim to be an inclusive brand.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:11.818Z",
    importedBy: "entity-db-cli",
  },
};
